import { render, staticRenderFns } from "./PreviousOwnershipsEditor.vue?vue&type=template&id=1089b7ac&scoped=true"
import script from "./PreviousOwnershipsEditor.vue?vue&type=script&lang=js"
export * from "./PreviousOwnershipsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1089b7ac",
  null
  
)

export default component.exports